module.exports = __webpack_public_path__ + "img/festival2.494ea8ae.jpg";